<template>
  <!--stateStorage="session"
    stateKey="dt-state-demo-session"-->
  <DataTable
    :value="listDataService"
    :lazy="true"
    class="p-datatable-responsive"
    selectionMode="single"
    data-key="id"
    @page="onPage($event)"
    :paginator="pagination"
    :totalRecords="totalRecords"
    :rows="paginationRows"
    :loading="loading"
    :first="firstRecordIndex"
    :scrollable="(scrollHeight !== '' ? true : false) "
    :scrollHeight="scrollHeight"
    :autoLayout="true"
    filterMatchMode="startsWith"
    :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
    :currentPageReportTemplate=" $constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM+' {totalRecords}'"
    :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
  >
    <Column
      v-for="c in model.getDisplayFields()"
      :key="c.key"
      :field="getField(c)"
      :header="getLabel(c)"
      :ref="getField(c)"
      :filterMatchMode="getFilterMatch(c)"
      :sortable="getSortable(c)"
      :bodyClass="(c.class ? 'txt-' + c.class : '')"
      :bodyStyle="getHeaderStyle(c)"
      :headerStyle="getHeaderStyle(c)"
      :headerClass="(c.class ? 'txt-' + c.class : '')"
    >
      <template #body="slotProps">
        <!--{{c}}-->
        <img
          v-if="getType(c) == 'Image'"
          :src="getData(c, slotProps.data)"
          style="width: 80px; height: 80px"
        />
        <div
          v-else-if="c.type == 'Text'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="c.type == 'Boolean'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'CustomUrl'"
          v-html="callbackCustomUrl(c, slotProps.data)"
          @click="redirectList(slotProps.data, $event)"
          :style="(c.style ? c.style : '')"
        ></div>
        <Checkbox
          v-else-if="getType(c) == 'Checkbox'"
          v-model="slotProps.data[slotProps.column.field]"
          :binary="true"
          @change="onInputChange($event, slotProps.data, c)"
        />
        <div v-else-if="getType(c) == 'MultiSelect'"  v-html="callbackDataMultiSelect( c ,slotProps.data)"></div>
        <div v-else>
          <div v-if="c.custom">
            <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge"  />
            <div v-if="c.custom == 'SelectionText'"  v-html="callbackDataSelect( c ,slotProps.data)"></div>
          </div>
          <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
        </div>


      </template>
      <template v-if="c.filter" #filter>
        <InputText
          v-if="c.filter.type == 'input'"
          type="text"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :placeholder="getFilterPlaceHolder(c)"
          @keyup="onFilter($event,c.filter.type,c.key)"
        />
        <Dropdown
          :key="countDropdown"
          v-if="c.filter.type == 'select'"
          v-model="filters[getField(c)]"
          :options="getFilterOptions(c.key)"
          :optionLabel="c.filter.optionLabel"
          :optionValue="c.filter.optionKey"
          :placeholder="getFilterPlaceHolder(c)"
          class="p-column-filter"
          :showClear="true"
          appendTo="body"

          @change="onFilter($event,c.filter.type,c.key)"
        >
          <template #option="slotProps">
            <div class="p-clearfix">
              <span
                :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                >{{ slotProps.option[c.filter.optionLabel] }}</span
              >
            </div>
          </template>
        </Dropdown>
        <DropdownScrollable
          v-if="c.filter.type == 'SelectScroll'"
          :limit="options[c.key]?.limit"
          :loading="options[c.key]?.loading"
          v-model="filters[getField(c)]"
          :options="options[c.key]?.items"
          :total="options[c.key]?.total"
          @click="(value) => onEventOptions('click', c.key, value, c.filter.type)"
          @keyup="(value) => onEventOptions('keyup', c.key, value, c.filter.type)"
          @scroll="(value) => onEventOptions('scroll', c.key, value, c.filter.type)"
          @offset="(value) => onEventOptions('offset', c.key, value, c.filter.type)">
          <template #label="slotProps">
            <div class="p-clearfix">
              <span>{{ slotProps[c.filter.optionLabel] }}</span>
            </div>
          </template>
        </DropdownScrollable>
        <Calendar
          v-if="c.filter.type == 'DateRange'"
          :showOnFocus="false"
          :monthNavigator="true"
          :yearNavigator="true"
          :yearRange="yearRange"
          dateFormat="yy-mm-dd" 
          :placeholder="getFilterPlaceHolder(c)"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :showIcon="true"
          selectionMode="range"
          appendTo="body"
          :showClear="true"
          :showButtonBar="true"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          style="width: 200px;"
          />
      </template>
    </Column>
    <Column
      v-if="actions"
      headerStyle="width: 10em; text-align: center"
      bodyStyle="width: 10em; text-align: center"
    >
      <template #body="slotProps">
        <span class="p-column-title">Actions</span>
        {{ slotProps.data.color }}
        <Button
          v-for="(a, k) in actions.rows(slotProps.data)"
          :key="k"
          type="button"
          :icon="getIcon(a.icon)"
          :class="getClass(a.name)"
          :disabled="getDisabled(a.disabled)"
          style="margin: 2px"
          v-on:click="actionsClicked(k, a, slotProps)"
        ></Button>
      </template>
      <template #header="slotProps">
        <Button
          v-if="actions.header"
          type="button"
          :icon="getIcon(actions.header.icon)"
          :class="getClass(actions.header.name)"
          v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"
        ></Button>
      </template>
    </Column>
    <template #empty>
      <div class="text-center">{{ $t('datatable.empty') }}</div>
    </template>
    <template #loading>
      <div class="text-center">{{ $t('datatable.loading') }}</div>
    </template>
    <Dialog header="Rất cảnh báo" :visible.sync="popupWarning" >
      <h1 class="txt-center txt-required">HỆ THỐNG ĐANG PHÁT TRIỂN  !!!!!!!!!!!!!</h1>
    </Dialog>
  </DataTable>
</template>

<script>
import moment from "moment-timezone";
import ApiRepository from "@/core/ApiRepository";
import DropdownScrollable from '@/components/DropdownScrollable';
export default {
  components:{
    DropdownScrollable
  },
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    whereKeyList: Object,
    company: Object,
    department_obj:Object,
    company_id: String
  },
  data() {
    return {
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 120,
      totalRecords2: 12,
      test: null,
      listDataService:null,
      filtersCustom: {},
      lazyParams: {},
      page_transaction:null,
      firstRecordIndex:0,
      yearRange : "2022:2300",
      time_zone_local : moment.tz.guess(true),
      popupWarning: false
    };
  },
  watch: {
    // async "$props.company"() {
    //   await this.onLazyEvent();
    // }
  },
  async created() {
    var year = new Date().getFullYear()
    var yearRange = '2022:'+(year+100);
    this.yearRange = yearRange+''
    this.test = this.tableData;
  },
  mounted () {
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
        this.firstRecordIndex = this.lazyParams.first;
        // console.log("this.lazyParams:22222222",this.lazyParams);
        /*if (this.lazyParams){
          this.filters = (this.lazyParams.filters) ? this.lazyParams.filters : {};
        }*/
      }
    }
    this.loading = false
    this.countDropdown++;
    this.onLazyEvent();
  },
  methods: {
    async onEventOptions(e, key, data, type) {
      this.$delete(this.options[key].filters, 'name');
      if (data) {
        this.options[key].filters.name = data;
      }
      this.$emit("onEventOptions", {event: e, key:key, data: this.options[key]});
      if (e == 'click') {
        await this.onFilter(e,type,key);
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    cannotEdit(col) {
      if (col.edit && col.edit.edit == false) return true;
      return false;
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      // console.log("this.options:",this.options)
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("LL");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("DD/MM/yyyy HH:mm");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          // console.log("col.models:",col.models);
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else if(col.type == "Boolean"){
        value = (row[col.key]) ? `<i class="pi pi-check success bold"></i>` : `<i class="pi pi-times danger bold"></i>`;
      } else {
        if (col.key == "zone" && row[col.key]?.name) {
          value = row[col.key].name;
        } else {
          value = row[col.key];
        }
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      }
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn`;
      } else if (col.filter.type == "input") {
        return `Nhập`;
      } else {
        return ``;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams:this.lazyParams
      });
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
    redirectList(data, e) {
      let clickedElId = e.target.id
      if (clickedElId === 'list-situation') {
        // var id = data.id;
        // var path = `/admin/list-situation/${id}`;
        var path = `/admin/list-situation`;
        this.$router.push({path: path, query: {company_id: this.company?.id, department_id: data?.department_id}})
        // this.popupWarning = true;
      }
    },
    callbackCustomUrl(c,data){
      var text = ''
      switch(c.key) {
        case 'total_situation':
          if (this.$store.getters.controllers?.list_situation && this.$store.getters.controllers?.list_situation.includes('view')) {
            text = '<a class="txt-link" id="list-situation" :data-id="'+data.id+'">'+data.count_total ?? 0+'</a>';
          } else {
            text = data.count_total ?? 0;
          }
          break;
        default:
          break;
      }
      // this.date_now
      return text;
    },
    callbackDataMultiSelect(c, data) {
      var text = "";
      switch(c.key) {
        case 'position':
          var positions = []
          data.users_position.map(m => {
            if (m?.position?.name) {
              positions.push(m.position.name);
            }
          })
          if (positions.length > 0) {
            positions.map(m => {
              text += `<div class="tag">${m}</div>`;
            })
          }
          break;
        case 'department':
          console.log("data",data)
          text = data.department.name
          // var departments = []
          // data.department.map(m => {
          //   if (m?.name) {
          //     departments.push(m.name);
          //   }
          // })
          // if (departments.length > 0) {
          //   departments.map(m => {
          //     text += `<div class="tag">${m}</div>`;
          //   })
          // }
          break;
        case 'zone':
          text = data?.zone?.name ?? '';
          break;
        default:
      }
      return text;
    },
    callbackDataSelect(c,data){
      var text = "";
      switch(c.key) {
        case 'active':
          if(data.active === true){
            text += '<div style="text-align: center;"><i class="fa fa-solid fa-check" style="color: #00973D;"/></div>';
          }else{
            text += '<div style="text-align: center;"><i class="fa fa-solid fa-times" style="color: #E95D57;"/></div>';
          }
          break;
        case 'department':
          text = data.active ? `<i class="pi pi-check success bold"></i>` : `<i class="pi pi-times danger bold"></i>`;
          break;
        default:
      }
      return text;
    },
   async dataList(lazyParams) {
      var filters = lazyParams.filters;
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var listData = [];
      var total = 0;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && company_id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var that = this;
        await ApiRepository.post("/_api/factory/list", {filters, limit: lazyParams.rows, offset: lazyParams.first, company_id: company_id}, {headers}).then(function (response) {
            var data = response.data.data;
            listData = data.factory;
            total = data.count;
        }).catch((err) => {
          that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: err,
              life: 3000
          });
        })
      }
     var dataRes = {
       listData: listData,
       total: total,
     };
     return dataRes;
    },
    async onLazyEvent() {
      this.lazyParams.filters = this.filtersCustom;
      console.log('this.filtersCustom:',this.filtersCustom)
      this.loading = true;
      var that =this;
      await this.dataList(this.lazyParams).then(async data => {
        if (data.listData.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }
        var stt = this.lazyParams.first;
        for (var i = 0; i < data.listData.length; i++) {
          stt++;
          data.listData[i].stt = stt;
          // if(data.listData[i].cities_lang){
          //   for (let j = 0; j < data.listData[i].cities_lang.length; j++) {
          //     const element = data.listData[i].cities_lang[j];
          //     if(element.lang == 'da'){
          //       data.listData[i].name_da = element.name
          //     }else if(element.lang == 'en'){
          //       data.listData[i].name_en = element.name
          //     }
          //   }
          // }
        }
        that.listDataService = data.listData;
        that.totalRecords = data.total;
        that.loading = false;
      });
    },
    onPage(event) {
      this.lazyParams = event;
      this.onLazyEvent();
    },
    async onFilter(event,type_input,key){
      //this.loading = true;
      this.tableData = this.test;
      if(type_input == "DateRange"){
        if(this.filters[key] !== null && this.filters[key][1]== null){
          return false;
        }
      }
      // this.filtersCustom[key] = {
      //   type_input:type_input,
      //   value:this.filters[key],
      // };
      console.log('this.filters:',this.filters);
      var filter = await this.$CoreService.convertFilter(type_input,key,this.filters);
      this.filtersCustom[key] = filter?.value;
      if(type_input == "SelectScroll"){
        if (event != 'click') {
          return;
        }
        if (key == 'department') {
          if (this.filtersCustom[key]?.id) {
            this.filtersCustom['department_id'] = this.filtersCustom[key].id;
          } else {
            this.$delete(this.filtersCustom, 'department_id');
          }
          this.$delete(this.filtersCustom, key);
        }
        if (key == 'zone') {
          if (this.filtersCustom[key]?.id) {
            this.filtersCustom['zone_id'] = this.filtersCustom[key].id;
          } else {
            this.$delete(this.filtersCustom, 'zone_id');
          }
          this.$delete(this.filtersCustom, key);
        }
      }
      this.lazyParams.first = 0;
      await this.onLazyEvent()
      /*setTimeout(() => {
        this.customers = this.datasource.slice(event.first, event.first + event.rows);
        this.loading = false;
      }, 500);*/
    },
  }
};
</script>
<style lang="scss">
.p-paginator-bottom{padding: 0 !important;}
/* .p-column-filter{
  width: 100%;
} */
.p-button-label-o{
  color : white;
}
.txt-required{
  color : red;
}
</style>
